<div *ngFor="let repeat of repeatArr" class="{{ 'bg-gray-500 animate-pulse ' + skeletonClasses }}"></div>
